/* eslint-disable no-comments/disallowComments */
import { SelectOption } from '../models';
import { DriverStatusModel, DriverStatusObjectModel } from '../models/driver-status.model';
import { LogRecordStatus } from './logbook';

export enum OnlineStatusEnum {
  ONLINE = 'online',
  OUT_OF_REACH = 'out-of-reach',
  OFFLINE = 'offline',
}

export enum DriverStatusEnum {
  DRIVING = 'driving',
  ON_DUTY = 'on-duty',
  SLEEPER_BERTH = 'sleeper-berth',
  YM = 'yard-move',
  PC = 'personal-conveyance',
  OFF = 'off-duty',
}

export const DriverStatusObject: DriverStatusObjectModel = {
  driving: {
    name: LogRecordStatus.Driving,
    iconConfig: {
      text: 'DR',
      light: { bg: '#E1FBEA', color: '#16B364', counterColor: '#FFFFFF', counterBg: '#16B364' },
      dark: { bg: '#082B13', color: '#57D175', counterColor: '#FFFFFF', counterBg: '#2f7a41' },
    },
    active: false,
  },
  onDuty: {
    name: LogRecordStatus.OnDuty,
    iconConfig: {
      text: 'ON',
      light: { bg: '#E1F1FF', color: '#007AFF', counterColor: '#FFFFFF', counterBg: '#007AFF' },
      dark: { bg: '#162655', color: '#5EABFC', counterBg: '#477cb3' },
    },
    active: false,
  },
  sleepBerth: {
    name: LogRecordStatus.SleeperBerth,
    iconConfig: {
      text: 'SB',
      light: { bg: '#FFF6DB', color: '#FF9F0A', counterColor: '#FFFFFF', counterBg: '#FF9F0A' },
      dark: { bg: '#481600', color: '#FFB91B', counterBg: '#ae7e11' },
    },
    active: false,
  },
  yardMove: {
    name: LogRecordStatus.YardMove,
    iconConfig: {
      text: 'YM',
      light: { bg: '#EBEFFF', color: '#2269EE', counterColor: '#FFFFFF', counterBg: '#2269EE' },
      dark: { bg: '#162655', color: '#5EABFC', counterBg: '#477cb3' },
    },
    active: false,
  },
  personalConveyance: {
    name: LogRecordStatus.PersonalConveyance,
    iconConfig: {
      text: 'PC',
      light: { bg: '#F6E1F4', color: '#B605A4', counterColor: '#FFFFFF', counterBg: '#B605A4' },
      dark: { bg: '#252629', color: '#C7C6CA', counterBg: '#717171' },
    },
    active: false,
  },
  off: {
    name: LogRecordStatus.OffDuty,
    iconConfig: {
      text: 'OFF',
      light: { bg: '#E5E5EA', color: '#808080', counterColor: '#FFFFFF', counterBg: '#808080' },
      dark: { bg: '#252629', color: '#C7C6CA', counterBg: '#717171' },
    },
    active: false,
  },
  powerOff: {
    name: LogRecordStatus.PowerOffConventional,
    iconConfig: {
      text: 'OFF',
      icon: 'engine_off',
      light: { bg: '#ed6a61', color: '#ed6a61', counterBg: '#ed6a61' },
      dark: { bg: '#ed6a61', color: '#ed6a61', counterBg: '#ed6a61' },
    },
    active: false,
  },
  powerOn: {
    name: LogRecordStatus.PowerOnConventional,
    iconConfig: {
      text: 'ON',
      icon: 'engine_on',
      light: { bg: '#5eb072', color: '#5eb072', counterBg: '#5eb072' },
      dark: { bg: '#5eb072', color: '#5eb072', counterBg: '#5eb072' },
    },
    active: false,
  },
  intermediate: {
    name: LogRecordStatus.IntermediateConventional,
    iconConfig: {
      text: 'OFF',
      icon: 'intermediate-dot',
      light: { bg: '#F2F2F7', color: '#1870EC', counterBg: '#1870EC' },
      dark: { bg: '#F2F2F7', color: '#1870EC', counterBg: '#1870EC' },
    },
    active: false,
  },
  certification: {
    name: LogRecordStatus.Certification,
    iconConfig: {
      text: 'OFF',
      icon: 'stylus_note',
      externalIcon: true,
      light: { bg: '#F2F2F7', color: '#2269EE', counterBg: '#2269EE' },
      dark: { bg: '#F2F2F7', color: '#2269EE', counterBg: '#2269EE' },
    },
    active: false,
  },
  login: {
    name: LogRecordStatus.Login,
    iconConfig: {
      text: 'Login',
      icon: 'login',
      externalIcon: true,
      light: { bg: '#F2F2F7', color: '#5eb072', counterBg: '#5eb072' },
      dark: { bg: '#F2F2F7', color: '#5eb072', counterBg: '#5eb072' },
    },
    active: false,
  },
  logout: {
    name: LogRecordStatus.Logout,
    iconConfig: {
      text: 'Logout',
      icon: 'logout',
      externalIcon: true,
      light: { bg: '#F2F2F7', color: '#48484A', counterBg: '#c7c6ca' },
      dark: { bg: '#F2F2F7', color: '#48484A', counterBg: '#c7c6ca' },
    },
    active: false,
  },
};

/* export const DriverStatus: SelectOption[] = [
  { value: DriverStatusEnum.DRIVING, label: 'Driving' },
  { value: DriverStatusEnum.ON_DUTY, label: 'ON Duty' },
  { value: DriverStatusEnum.SLEEPER_BERTH, label: 'Sleeper Berth' },
  { value: DriverStatusEnum.YM, label: 'ON (YM)' },
  { value: DriverStatusEnum.PC, label: 'OFF (PC)' },
  { value: DriverStatusEnum.OFF, label: 'OFF Duty' },
]; */

export const DriverStatus: SelectOption[] = [
  { value: DriverStatusEnum.DRIVING, label: 'DR' },
  { value: DriverStatusEnum.ON_DUTY, label: 'ON' },
  { value: DriverStatusEnum.SLEEPER_BERTH, label: 'SB' },
  { value: DriverStatusEnum.YM, label: 'ON (YM)' },
  { value: DriverStatusEnum.PC, label: 'OFF (PC)' },
  { value: DriverStatusEnum.OFF, label: 'OFF' },
];

export const driverStatusArray: DriverStatusModel[] = [
  DriverStatusObject.driving,
  DriverStatusObject.off,
  DriverStatusObject.onDuty,
  DriverStatusObject.sleepBerth,
  DriverStatusObject.yardMove,
  DriverStatusObject.personalConveyance,
];
